import {Vue} from '~/addiesaas'
import LairdndApp from './lairdnd-app'
import GuestLayout from './guest-layout'
import MainLayout from './main-layout'
import HomeLayout from './home-layout'
import NotFoundLayout from './not-found-layout'

const requires = {
    LairdndApp,
    GuestLayout,
    MainLayout,
    HomeLayout,
    NotFoundLayout,
}

Object.values(requires).forEach(component => {
    Vue.component(component.name, component)
})

export default requires
